<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <main-sub-page-toolbar icon="mdi-image-search-outline">
              {{ $t("homeMenuCartInfoOrderStatusTitle") }}
              <v-avatar
                color="error"
                size="28"
                class="ml-1"
                v-if="$store.state.storeOrders.orders.length > 0"
              >
                <span class="white--text subtitle-2">
                  {{
                    $store.state.storeOrders.orders.filter((x) =>
                      statusItems.includes(x.status.toString())
                    ).length
                  }}
                </span>
              </v-avatar>
            </main-sub-page-toolbar>
          </v-flex>
          <v-flex xs12 class="mx-1 mb-6 pa-0 pb-10">
            <v-card
              class="#505050--text animated fadeIn"
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark'
                  ? 'border: 1px solid darkgray; background-color: whitesmoke'
                  : 'border: none; background-color: white'
              "
            >
              <v-card-text
                v-if="$store.state.storeOrders.orders.length > 0"
                class="pa-1 my-0"
              >
                <div class="d-flex align-center flex-wrap pa-0 ma-0 mt-1 ml-1">
                  <div
                    class="ma-0 pa-0 mr-1"
                    style="height: 45px; width: 165px"
                  >
                    <v-select
                      :label="$t('userOrdersDisplayList')"
                      outlined
                      dense
                      class="ma-0 pa-0"
                      item-text="title"
                      item-value="days"
                      :items="toggleFilterItems"
                      v-model="$store.state.storeOrders.viewDate"
                      @change="setNewViewDate"
                    ></v-select>
                  </div>
                  <div class="ma-0 pa-0 mt-1" style="height: 45px">
                    <v-btn-toggle
                      multiple
                      dense
                      class="pa-0 ma-0"
                      v-model="statusItems"
                    >
                      <v-btn value="0" min-width="40" @click.stop>
                        <v-icon color="error" small>mdi-circle-slice-8</v-icon>
                        <span class="hidden-xs-only pl-1">
                          {{ $t("userOrdersStatus0Title") }}
                        </span>
                      </v-btn>
                      <v-btn value="1" min-width="40" @click.stop>
                        <v-icon color="warning" small
                          >mdi-circle-slice-8</v-icon
                        >
                        <span class="hidden-xs-only pl-1">
                          {{ $t("userOrdersStatus1Title") }}
                        </span>
                      </v-btn>
                      <v-btn value="2" min-width="40" @click.stop>
                        <v-icon color="success" small
                          >mdi-circle-slice-8</v-icon
                        >
                        <span class="hidden-xs-only pl-1">
                          {{ $t("userOrdersStatus2Title") }}
                        </span>
                      </v-btn>
                      <v-btn value="3" min-width="40" @click.stop>
                        <v-icon small>mdi-circle-slice-8</v-icon>
                        <span class="hidden-xs-only pl-1">
                          {{ $t("userOrdersStatus3Title") }}
                        </span>
                      </v-btn>
                    </v-btn-toggle>
                  </div>
                </div>
                <v-progress-linear
                  v-show="loading"
                  indeterminate
                  color="primary"
                ></v-progress-linear>
                <div
                  style="background-color: #fcfcfc; border: 1px solid gainsboro"
                  class="ma-0"
                >
                  <v-expansion-panels v-model="openedPanel" multiple accordion>
                    <div
                      class="my-4"
                      style="font-weight: bold"
                      v-if="
                        $store.state.storeOrders.orders.filter((x) =>
                          statusItems.includes(x.status.toString())
                        ) == 0
                      "
                    >
                      <v-icon small class="mb-1"
                        >mdi-emoticon-sad-outline</v-icon
                      >
                      <span class="ml-2 subtitle-2">
                        {{ $t("userOrdersEmptyMsg") }}
                      </span>
                    </div>
                    <v-expansion-panel
                      v-else
                      v-for="item in $store.state.storeOrders.orders.filter(
                        (x) => statusItems.includes(x.status.toString())
                      )"
                      :key="item.id"
                    >
                      <v-expansion-panel-header class="pa-3 pb-2">
                        <div class="d-flex align-center flex-wrap pa-0 ma-0">
                          <div class="d-flex align-center flex-wrap pa-0 ma-0">
                            <!-- EXPORT PDF HIDDEN CONTENT -->
                            <div v-show="false">
                              <div :id="'exportPdf-' + item.orderId">
                                <export-order-info
                                  :item="item"
                                ></export-order-info>
                              </div>
                            </div>

                            <!-- export pdf button -->
                            <div
                              class="d-flex align-center flex-wrap pa-0 ma-0"
                            >
                              <div class="mb-1">
                                <v-icon
                                  medium
                                  @click="exportOrderToPdf(item.orderId)"
                                  @click.stop
                                  class="secondary--text hover-item mr-2"
                                  >mdi-file-export</v-icon
                                >
                              </div>
                            </div>

                            <div
                              class="d-flex align-center flex-wrap pa-0 ma-0"
                            >
                              <div class="mb-1 mr-2">
                                <v-icon
                                  small
                                  :color="getStatusColor(item.status)"
                                  class="mr-1"
                                  >mdi-circle-slice-8</v-icon
                                >
                                {{ getStatusName(item.status) }}
                              </div>
                            </div>

                            <div
                              class="
                                d-flex
                                align-center
                                flex-wrap
                                pa-0
                                ma-0
                                pr-1
                              "
                            >
                              <div
                                v-for="(item2, index2) in item.storeCart.cart"
                                :key="index2"
                              >
                                <v-icon
                                  v-if="item2.module == G_MODULE_PHOTO_ORDER"
                                  small
                                  :color="
                                    item2.done || item.status > 1
                                      ? 'success'
                                      : 'gray'
                                  "
                                  class="mr-1 mb-1"
                                  >mdi-image-multiple</v-icon
                                >
                                <span
                                  v-else-if="
                                    item2.module == G_MODULE_PHOTO_GIFT
                                  "
                                >
                                  <span v-if="item2.superType !== undefined">
                                    <v-icon
                                      v-if="item2.superType == 0"
                                      small
                                      :color="
                                        item2.done || item.status > 1
                                          ? 'success'
                                          : 'gray'
                                      "
                                      class="mr-1 mb-1"
                                      >mdi-package-variant</v-icon
                                    >
                                    <v-icon
                                      v-else-if="item2.superType == 1"
                                      small
                                      :color="
                                        item2.done || item.status > 1
                                          ? 'success'
                                          : 'gray'
                                      "
                                      class="mr-1 mb-1"
                                      >mdi-glass-mug</v-icon
                                    >
                                    <v-icon
                                      v-else-if="item2.superType == 2"
                                      small
                                      :color="
                                        item2.done || item.status > 1
                                          ? 'success'
                                          : 'gray'
                                      "
                                      class="mr-1 mb-1"
                                      >mdi-collage</v-icon
                                    >
                                    <v-icon
                                      v-else-if="item2.superType == 3"
                                      small
                                      :color="
                                        item2.done || item.status > 1
                                          ? 'success'
                                          : 'gray'
                                      "
                                      class="mr-1 mb-1"
                                      >mdi-picture-in-picture-bottom-right</v-icon
                                    >
                                    <v-icon
                                      v-else-if="item2.superType == 4"
                                      small
                                      :color="
                                        item2.done || item.status > 1
                                          ? 'success'
                                          : 'gray'
                                      "
                                      class="mr-1 mb-1"
                                      >mdi-wallet-giftcard</v-icon
                                    >
                                    <v-icon
                                      v-else-if="item2.superType == 5"
                                      small
                                      :color="
                                        item2.done || item.status > 1
                                          ? 'success'
                                          : 'gray'
                                      "
                                      class="mr-1 mb-1"
                                      >mdi-resize</v-icon
                                    >
                                    <v-icon
                                      v-else-if="item2.superType == 6"
                                      small
                                      :color="
                                        item2.done || item.status > 1
                                          ? 'success'
                                          : 'gray'
                                      "
                                      class="mr-1 mb-1"
                                      >mdi-palette</v-icon
                                    >
                                  </span>
                                  <span v-else>
                                    <v-icon
                                      small
                                      :color="
                                        item2.done || item.status > 1
                                          ? 'success'
                                          : 'gray'
                                      "
                                      class="mr-1 mb-1"
                                      >mdi-glass-mug</v-icon
                                    >
                                  </span>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div class="d-flex align-center flex-wrap pa-0 ma-0">
                            <div class="mb-1 mr-2">
                              <v-icon small color="primary" class="mr-2"
                                >mdi-barcode-scan</v-icon
                              >
                              <strong>{{ item.orderId }}</strong>
                            </div>
                            <div class="mb-1 mr-2">
                              <v-icon small color="primary" class="mr-1"
                                >mdi-alarm-plus</v-icon
                              >
                              {{ $t("msgAddedTitle") }}
                              {{ timePassedSinceAdd(item.timestamp.seconds) }}
                            </div>
                            <div class="mb-1 mr-2">
                              <v-icon small color="primary" class="mr-1"
                                >mdi-walk</v-icon
                              >
                              {{ item.deliveryName }}
                            </div>
                            <div class="mb-1 mr-2">
                              <v-icon small color="primary" class="mr-1"
                                >mdi-account-cash</v-icon
                              >
                              {{ item.deliveryTypeString }}
                            </div>
                            <div class="mb-1 mr-2">
                              <v-icon small color="primary" class="mr-2"
                                >mdi-cash-multiple</v-icon
                              >
                              <strong>{{
                                price(item.deliveryFinalSum)
                              }}</strong>
                            </div>
                          </div>

                          <div
                            class="d-flex align-center flex-wrap pa-0 ma-0 mt-1"
                            v-if="item.messageForStudio.length > 0"
                          >
                            <v-icon medium color="red" class="mr-2"
                              >mdi-message-reply-text</v-icon
                            >
                          </div>

                          <div
                            class="
                              d-flex
                              align-center
                              flex-wrap
                              pa-0
                              pt-1
                              pb-1
                              ma-0
                            "
                          >
                            <v-btn
                              v-if="item.status == 2"
                              @click.stop
                              outlined
                              @click="removeCompletedOrder(item)"
                            >
                              {{ $t("userOrdersCloseOrderBtn") }}
                            </v-btn>

                            <v-btn
                              v-if="item.status == 0"
                              @click.stop
                              outlined
                              @click="
                                tempItem = item;
                                dialogCancel = true;
                              "
                            >
                              {{ $t("userOrdersCancelOrderBtn") }}
                            </v-btn>
                          </div>
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="ma-0 pa-0 pb-4">
                        <div v-if="item.deliveryType == 'prepay'" class="px-4">
                          <v-img
                            :src="item.qrCode"
                            style="max-width: 400px; max-height: 400px"
                          >
                          </v-img>
                          <div
                            class="
                              subtitle-1
                              font-weight-regular
                              px-4
                              py-2
                              mb-2
                            "
                            style="background-color: #e74c3c; color: white"
                          >
                            <div>
                              {{ $t("userOrdersSendEmailPrepayHeaderTitle") }}
                            </div>
                            <div v-html="formatPrepayInfo"></div>
                            <div>
                              {{ $t("userOrdersSendEmailReferenceSubject") }}:
                              {{ item.qrCodeReference }}
                            </div>
                            <div>
                              {{ $t("userOrdersFullSummary") }}:
                              {{ price(item.deliveryFinalSum) }}
                            </div>
                          </div>
                        </div>
                        <display-order-info
                          :item="item"
                          mode="user"
                        ></display-order-info>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
              </v-card-text>
              <v-card-text v-else class="ma-0 py-5">
                <v-icon small>mdi-emoticon-sad-outline</v-icon>
                <span class="ml-2 subtitle-2">
                  {{ $t("userOrdersEmptyMsg") }}
                </span>
              </v-card-text>
            </v-card>

            <!-- CANCEL ORDER CONFIRM DIALOG -->
            <dialog-basic-yes-no
              :active="dialogCancel"
              @clickYes="
                removeOrder(tempItem);
                dialogCancel = false;
              "
              @clickNo="dialogCancel = false"
              icon="mdi-comment-question-outline"
              :title="$t('msgQuestion')"
              >{{ $t("userOrdersCancelOrderQuestion") }}
              {{ tempItem.orderId }}?</dialog-basic-yes-no
            >
          </v-flex>
          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'home' })"
          ></simple-navigation-button>
        </v-layout>
      </div>

      <!-- PLEASE WAIT DIALOG -->
      <v-dialog
        v-model="dialogWait"
        persistent
        max-width="400"
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-card-title class="headline">{{
            $t("userNewOrderPleaseWaitTitle")
          }}</v-card-title>
          <v-card-text class="d-flex">
            <v-spacer></v-spacer>
            <v-progress-linear
              color="primary"
              height="10"
              indeterminate
            ></v-progress-linear>
            <v-spacer></v-spacer>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-main>
  </v-container>
</template>

<script>
import firebase from "firebase/app";
import "firebase/functions";
import AppNavigation from "@/views/AppNavigation";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";
import ExportOrderInfo from "@/components/orderInfo/ExportOrderInfo";
import DialogBasicYesNo from "@/components/DialogBasicYesNo";
import DisplayOrderInfo from "@/components/orderInfo/DisplayOrderInfo";
import { G_MODULE_PHOTO_ORDER, G_MODULE_PHOTO_GIFT } from "@/constants";
import { G_MODULE_ALL } from "@/constants";
import moment from "moment";
import html2pdf from "html2pdf.js";
import { usersCollection } from "@/firebase";
//import axios from "axios";

export default {
  name: "userOrders",
  components: {
    AppNavigation,
    MainSubPageToolbar,
    DialogBasicYesNo,
    SimpleNavigationButton,
    ExportOrderInfo,
    DisplayOrderInfo,
  },
  data() {
    return {
      netBackImage: require("@/assets/netBack.png"),
      loading: false,
      statusItems: this.$store.state.storeOrders.statusItems,
      dialogCancel: false,
      tempItem: {},
      dialogWait: false,
      openedPanel: [],
      info: null,
    };
  },
  computed: {
    formatPrepayInfo() {
      return this.$store.state.storeClient.client.prepaySettings.prepayInfo
        .split("\n")
        .join("<br />");
    },
  },
  methods: {
    async removeCompletedOrder(item) {
      this.dialogWait = true;
      // nastavimo za prevzeto
      await this.$store.dispatch("setOrderPackages", {
        id: item.id,
        status: 3,
        send: 2,
        status3SetBy: this.$store.state.storeAuth.userProfile.fullName,
        status3Timestamp: new Date(),
        hasFiles: false,
      });
      this.dialogWait = false;

      this.$store.dispatch("getOrderItems", {
        client: this.$store.state.storeClient.client.basicSettings.name,
        uid: this.$store.state.storeAuth.user.uid,
        days: this.$store.state.storeOrders.viewDate,
      });
    },
    async removeOrder(item) {
      this.dialogWait = true;
      // nastavimo za prevzeto, dodamo tag "canceled: true"
      const res = await this.$store.dispatch("setOrderPackages", {
        id: item.id,
        canceled: true,
        status: 3,
        send: 2,
        status3SetBy: this.$store.state.storeAuth.userProfile.fullName,
        status3Timestamp: new Date(),
        hasFiles: false,
      });

      if (res == "OK") {
        // če je prevzeto šlo čez, potem pošljemo še emaile adminom
        usersCollection
          .where("client", "==", item.client)
          .where("isAdmin", "==", true)
          .where("isAdminSendNewPackagesMessage", "==", true)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              let sendFunctionEmailMsg = firebase
                .functions()
                .httpsCallable("sendRealEmailMsg");
              sendFunctionEmailMsg({
                client: this.$store.state.storeClient.client.basicSettings.name,
                recipientEmail: doc.data().email,
                senderFullName:
                  this.$store.state.storeClient.client.basicSettings.fullName,
                senderEmail:
                  this.$store.state.storeClient.client.environmentSettings
                    .autoResponseEmail,
                senderSubject:
                  this.$t("homeMenuCartInfoCancelOrderEmailSubjectTitle") +
                  item.orderId +
                  " (" +
                  this.price(item.deliveryFinalSum) +
                  ")",
                senderBody:
                  item.fullName +
                  this.$t("homeMenuCartInfoCancelOrderEmailSubjectBody1") +
                  item.orderId +
                  ".",
              });
            });
          });

        // odštejemo znesek v bazi
        this.$store.dispatch("setUserStats", {
          uid: this.$store.state.storeAuth.user.uid,
          client: this.$store.state.storeClient.client.basicSettings.name,
          orders: -1,
          ordersSum: -item.deliveryFinalSum,
          timestamp: new Date(Date.now()),
        });

        // nekaj podatkov ne moremo dobiti iz item-a, zato moramo te podatke prebrati najprej iz orders baze
        let tItem = await this.$store.dispatch("readOrder", {
          id: item.id,
        });

        // odštejemo zneske in statistiko v bazah orderDay, orderMonth in orderYear
        let removeStats = firebase.functions().httpsCallable("removeStats");

        try {
          await removeStats(
            Object.assign({}, tItem, {
              collection: "orderDay",
            })
          )
            .then((res) => {
              console.log(res);
            })
            .catch((error) => {
              console.log(error);
            });
        } catch (error) {
          console.log(error);
          return;
        }

        try {
          await removeStats(
            Object.assign({}, tItem, {
              collection: "orderMonth",
            })
          )
            .then((res) => {
              console.log(res);
            })
            .catch((error) => {
              console.log(error);
            });
        } catch (error) {
          console.log(error);
          return;
        }

        try {
          await removeStats(
            Object.assign({}, tItem, {
              collection: "orderYear",
            })
          )
            .then((res) => {
              console.log(res);
            })
            .catch((error) => {
              console.log(error);
            });
        } catch (error) {
          console.log(error);
          return;
        }

        // refresh orders
        this.$store.dispatch("getOrderItems", {
          client: this.$store.state.storeClient.client.basicSettings.name,
          uid: this.$store.state.storeAuth.user.uid,
          days: this.$store.state.storeOrders.viewDate,
        });

        this.$store.commit({
          type: "showSnackbar",
          color: "success",
          message: this.$t("userOrdersCloseOrderSucess"),
        });
        this.dialogWait = false;
      } else {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: this.$t("userOrdersCloseOrderError"),
        });
        this.dialogWait = false;
      }
    },
    exportOrderToPdf(orderId) {
      let element = document.getElementById("exportPdf-" + orderId);
      let opt = {
        filename: orderId + ".pdf",
        image: { type: "jpeg", quality: 0.9 },
        html2canvas: { scale: 2, scrollX: 0, scrollY: 0 },
        jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
      };

      // New Promise-based usage:
      html2pdf().from(element).set(opt).save();
    },
    getStatusColor(status) {
      if (status == 0) {
        return "error";
      } else if (status == 1) {
        return "warning";
      } else if (status == 2) {
        return "green";
      } else {
        return "black";
      }
    },
    getStatusName(status) {
      if (status == 0) {
        return this.$t("userOrdersStatus0Title");
      } else if (status == 1) {
        return this.$t("userOrdersStatus1Title");
      } else if (status == 2) {
        return this.$t("userOrdersStatus2Title");
      } else {
        return this.$t("userOrdersStatus3Title");
      }
    },
    async setNewViewDate() {
      this.loading = true;
      try {
        await this.$store
          .dispatch("getOrderItems", {
            client: this.$store.state.storeClient.client.basicSettings.name,
            uid: this.$store.state.storeAuth.user.uid,
            days: this.$store.state.storeOrders.viewDate,
          })
          .then(() => {
            this.loading = false;
          });
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
  },
  beforeUpdate() {
    //console.log(">>> BEFORE UPDATE forceUpdate");
    this.$forceUpdate(); // update za dodano pred xx min
  },
  created() {
    this.G_MODULE_PHOTO_ORDER = G_MODULE_PHOTO_ORDER;
    this.G_MODULE_PHOTO_GIFT = G_MODULE_PHOTO_GIFT;
    this.G_MODULE_ALL = G_MODULE_ALL;
    // dopolnimo seznam za iskanje po letih od 2020 do now()
    let cYear = Number(moment().format("Y"));
    if (cYear >= 2020)
      for (var i = 2020; i <= cYear; i++) {
        this.toggleFilterItems.push({
          title: this.$t("userOrdersDateYear") + " " + i,
          days: i,
        });
      }
  },
  async mounted() {
    // prvo naročilo odpremo, da se vidijo detajli, predvsem zaradi predračunov
    this.openedPanel.push(0);

    /*console.log(">>> MOUNTED getOrdersInfo dispatch");
    this.$store.dispatch("getOrderItems", {
      client: this.$store.state.storeClient.client.basicSettings.name,
      uid: this.$store.state.storeAuth.user.uid,
      days: 30,
    });*/
  },
};
</script>
<style>
.v-expansion-panel::before {
  box-shadow: none;
}
.v-expansion-panel-content__wrap {
  padding: 0;
  margin: 0;
}
</style>
